// Known icon suffixes exposed by the icons.
const TECH_SPEC_SUFFIXES = [
    'accessories',
    'colourmaterialfinish',
    'connectivity',
    'controlpanel',
    'drinks',
    'features',
    'functions',
    'miscellaneous',
    'technicaldata',
]

// Default tab order for the three compare/spec sections.
const CATEGORY_SUFFIX_BY_INDEX = {
    0: 'drinks',
    1: 'technicaldata',
    2: 'functions',
}

// Normalize a label/key so we can match it against grouped tech-spec ids.
const normalizeKey = (value) =>
    String(value || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

// Remove any known tech-spec suffix from an icon key, leaving only the product family.
const stripKnownSuffix = (value) => {
    const normalizedValue = normalizeKey(value).replace(/^\./, '')
    const suffix = TECH_SPEC_SUFFIXES.find((candidate) => normalizedValue.endsWith(`_${candidate}`))

    if (!suffix) return normalizedValue

    return normalizedValue.slice(0, -(suffix.length + 1))
}

// Use the first grouped tech-spec key to infer the product family,
// falling back to a known key when the grouped data is unavailable.
const getFamilyKeyFromGroupedTechSpecs = (groupedTechSpecs, fallbackKey = '') => {
    const groupedKeys = Object.keys(groupedTechSpecs || {})

    return stripKnownSuffix(groupedKeys[0] || fallbackKey)
}

// Resolve the category suffix for the active tab/category.
// Technical data maps to the features icon contract.
const getCategorySuffix = ({category, index, categories, sourceKey}) => {
    const normalizedSourceKey = normalizeKey(sourceKey)
    const suffixFromSourceKey = TECH_SPEC_SUFFIXES.find((candidate) =>
        normalizedSourceKey.endsWith(`_${candidate}`),
    )

    if (suffixFromSourceKey) {
        return suffixFromSourceKey
    }

    if (Array.isArray(categories) && categories[index]) {
        return CATEGORY_SUFFIX_BY_INDEX[index] || null
    }

    const normalizedCategory = normalizeKey(category)
    if (normalizedCategory.includes('bevand') || normalizedCategory.includes('drink')) {
        return 'drinks'
    }

    if (
        normalizedCategory.includes('dati tecnic') ||
        normalizedCategory.includes('technical') ||
        normalizedCategory.includes('feature')
    ) {
        return 'technicaldata'
    }

    if (normalizedCategory.includes('funzion') || normalizedCategory.includes('function')) {
        return 'functions'
    }

    return null
}

// Build the final DynamicIcon id, e.g. tech_spec_bean_to_cup_coffee_machines_drinks.
export const getTechSpecIconId = ({groupedTechSpecs, category, index, categories, sourceKey}) => {
    const familyKey = getFamilyKeyFromGroupedTechSpecs(groupedTechSpecs, sourceKey)
    const categorySuffix = getCategorySuffix({category, index, categories, sourceKey})
    const iconSuffix = categorySuffix === 'technicaldata' ? 'features' : categorySuffix

    if (!familyKey || !iconSuffix) {
        return ''
    }

    return `tech_spec_${familyKey}_${iconSuffix}`
}
